import ReferenceQueryPage from './ReferenceQueryPage.jsx'
import container from './container.js'

export default container(ReferenceQueryPage)
